import React, {Component} from 'react';
import objeler from '../objeler';
import Colorpicker from '../Colorpicker';
import ComboBox from "./ComboBox";
import 'react-dropdown/style.css'
import {convertFromRaw, convertToRaw, EditorState, Modifier} from 'draft-js'
import './modal.css'
import {Editor as Word} from '../../react-draft-wysiwyg/dist/react-draft-wysiwyg'
import '../../react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ScriptProperties from './scriptProperties'
import EditableSelect from './EditableSelect';
import StructuredBindingPanel from './StructuredBindingPanel';

const tabCharacter = "    ";
const fontItems = require('../../items/fontitems.json');
const fontnameItems = require('../../items/fontnameitems.json');
const aligmentItems = require('../../items/Alignment.json');
const dataTypeItems = require('../../items/DataType.json');

class TextProperties extends Component {
    options = [
        '6', '7', '8', '9'
    ];
    defaultOption = this.options[0];

    constructor(props) {
        super(props);
        this.child = React.createRef();
        let initEditorState = null;
        // FIX: Component yanlışlıkla ElementProps yokken render edilebilir (template apply / lifecycle).
        // Bu durumda boş editor ile başla; kullanıcı element'i tıkladığında modal yeniden initialize olur.
        const cs = objeler.ElementProps ? objeler.ElementProps.ContentState : null;
        if (cs == "" || cs == null || cs == undefined) {
            initEditorState = EditorState.createEmpty();
        } else
            initEditorState = EditorState.createWithContent(convertFromRaw(cs));
        this.state = {
            activeFontFamily: "Open Sans",
            activeBold: "false",
            editorState: initEditorState
        };
        this.onChangeEditorState = this.onChangeEditorState.bind(this);
        this.onTab = this.onTab.bind(this);
    };

    componentDidMount() {
        // FIX: Aynı sebepten guard
        if (!objeler.ElementProps) return;
        var tar = objeler.ElementProps.ContentState;
        console.log('DDDD', tar)
        this.setState({dataSourceValue: objeler.ElementProps.DataSource})
        this.getDatasourceItems();
        setTimeout(() => {
            try {
                this.child.select();
            } catch {
                try {
                    console.log('this.child ', this.child)
                    this.child.focus();
                } catch {
                    this.child.current.focusEditor()
                    var dia = null;
                    try {
                        dia = document.getElementsByClassName("MuiDialogContent-root")[0].getElementsByClassName("DraftEditor-root")[0];
                        console.log('this.child ', dia)
                        this.setState({
                            editorState: EditorState.moveSelectionToEnd(this.state.editorState)
                        });
                    } catch {
                    }
                }
            }
        }, 1);
    }

    updateInputValue(e) {
        objeler.tarik.Text = e.target.value;
    }

    changeColor = (clr, event) => {
        objeler.tarik.Color = clr.hex;
    };
    changeBgColor = (clr, event) => {
        objeler.tarik.BColor = clr.hex;
    };

    updateScriptValue(e) {
        objeler.tarik.Script = e.target.value;
    }

    onChangeIsScript(e) {
        this.setState({value: e.target.value});
        objeler.ElementProps.IsScript = e.target.checked;
    }

    getCurrentTextSelection = (currentState) => {
        const selectionState = currentState.getSelection();
        const anchorKey = selectionState.getAnchorKey();
        const currentContent = currentState.getCurrentContent();
        const currentContentBlock = currentContent.getBlockForKey(anchorKey);
        const start = selectionState.getStartOffset();
        const end = selectionState.getEndOffset();
        const selectedText = currentContentBlock.getText().slice(start, end);
        return selectedText;
    };

    insertText(textToInsert) {
        let editorState = this.state.editorState;
        const currentContent = editorState.getCurrentContent();
        const currentSelection = editorState.getSelection();
        let newContent = Modifier.replaceText(
            currentContent,
            currentSelection,
            textToInsert
        );
        const textToInsertSelection = currentSelection.set('focusOffset', currentSelection.getFocusOffset() + textToInsert.length);
        let inlineStyles = editorState.getCurrentInlineStyle();
        inlineStyles.forEach(inLineStyle => newContent = Modifier.applyInlineStyle(newContent, textToInsertSelection, inLineStyle));
        let newState = EditorState.push(editorState, newContent, 'insert-characters');
        newState = EditorState.forceSelection(newState, textToInsertSelection.set('anchorOffset', textToInsertSelection.getAnchorOffset() + textToInsert.length));
        return newState;
    }

    onTab(e) {
        e.preventDefault();
        this.setState({
            editorState: this.insertText(tabCharacter)
        });
        return;
        let inlineStyles = this.editorState.getCurrentInlineStyle();
        console.log('inlineStyles', inlineStyles)
        let currentState = this.state.editorState;
        console.log('currentState.getSelection()', currentState.getCurrentContent())
        let newContentState = Modifier.replaceText(
            currentState.getCurrentContent(),
            currentState.getSelection(),
            tabCharacter
        );
        this.setState({
            editorState: EditorState.push(currentState, newContentState, 'insert-characters')
        });
    }

    onChangeEditorState(editorState) {
        if (editorState.getCurrentContent().hasText()) {
            console.log('ZZZ', convertToRaw(editorState.getCurrentContent()))
            objeler.ElementProps.ContentState = convertToRaw(editorState.getCurrentContent());
            var dia = document.getElementsByClassName("MuiDialogContent-root")[0].getElementsByClassName("DraftEditor-root")[0];
            if (objeler.ElementProps.Object.properties.size.height < dia.scrollHeight)
                objeler.ElementProps.Object.properties.size.height = dia.scrollHeight;
        }
        this.setState({editorState});
    }

    onWordStateChange(e) {
        this.setState({value: e});
        objeler.ElementProps.ContentState = e;
    }

    onDataSourceChage(e) {
        this.setState({value: e});
        objeler.ElementProps.DataSource = e;
        this.setState({dataSourceValue: objeler.ElementProps.DataSource})
    }

    onStructuredBindingChange = (binding) => {
        if (!objeler.ElementProps) return;

        objeler.ElementProps.binding = binding;
        if (objeler.ElementProps.Object) {
            objeler.ElementProps.Object.binding = binding;
            objeler.ElementProps.Object.properties = {
                ...(objeler.ElementProps.Object.properties || {}),
                binding
            };
        }

        this.forceUpdate();
    }

    onAlignChage(e) {
        this.setState({value: e.target.value});
        objeler.ElementProps.Align = e.target.value;
    }

    onDataTypeChage(e) {
        this.setState({value: e.target.value});
        objeler.ElementProps.DataType = e.target.value;
    }

    onFontChage(e) {
        this.setState({value: e.target.value, text: e.target[e.target.selectedIndex].text});
        objeler.tarik.Font = e.target.value;
        objeler.tarik.FontFamily = e.target[e.target.selectedIndex].text;
    }

    onChangeMline(e) {
        objeler.ElementProps.MLine = e.target.checked;
    }

    onChangeBound(e) {
        this.setState({disabledBound: !this.state.disabledBound})
        objeler.ElementProps.Bound = e.target.checked;
        if (!objeler.ElementProps.Bound)
            objeler.ElementProps.DataSource = "";
        this.setState({dataSourceValue: objeler.ElementProps.DataSource})
    }

    onChangeBold(e) {
        objeler.ElementProps.Bold = e.target.checked;
    }

    onChangeItalic(e) {
        objeler.ElementProps.Italic = e.target.checked;
    }

    onFontSizeChage(e) {
        this.setState({FontSize: e.target.value})
        objeler.tarik.FontSize = e.target.value;
        objeler.ElementProps.FontSize = e.target.value;
    }

    getDatasourceItems() {
        var items = [];
        if (objeler.ModalDocParameters.DataSource.length < 1) return;
        for (let prop in objeler.ModalDocParameters.DataSource) {
            items.push({
                "value": objeler.ModalDocParameters.DataSource[prop].title,
                "label": objeler.ModalDocParameters.DataSource[prop].title
            });
        }
        items.push({"value": "", "label": "None"});
        return items;
    }

    getDatasourceValue(e) {
        return {value: e, label: e};
    }

    render() {
        // FIX: ElementProps yoksa hiçbir şey render etme.
        // Bu durum modal kapalıyken React lifecycle'ından gelen render çağrılarında oluşur.
        // Modal açıldığında Container.js objeler.ElementProps'u set eder, sonra render normal çalışır.
        if (!objeler.ElementProps) return null;
        const fontStyles = {
            values: [
                {
                    name: 'Regular',
                    value: 'Regular',
                },
                {
                    name: 'Bold',
                    value: 'Bold',
                },
                {
                    name: 'Italic',
                    value: 'Italic',
                },
                {
                    name: 'Bold Italic',
                    value: 'BoldItalic',
                },
            ],
            value: '?',
        };
        const {t, color, backgroundColor, type} = this.props;
        const prp = objeler["tarik"];
        const fontSizeStyle = {
            width: "60px",
            textAlign: 'center',
            height: "23px",
            borderWidth: "1px",
            textAlignVertical: "middle",
            marginTop: "0px",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const trStyle = {
            borderWidth: "1px",
        };
        const tdStyle = {
            color: "Black",
            textAlign: "left",
            valign: "bottom"
            , overflow: 'hidden'
        };
        const pStyle = {
            fontSize: "14px",
            height: "16px",
            width: "90px",
            color: "#000000",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const p2Style = {
            fontSize: "14px",
            height: "16px",
            width: "40px",
            color: "#000000",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const tableStyle = {
            left: "47px",
            width: "535px",
            height: "208px",
            zIndex: "6"
            , overflow: 'hidden'
        };
        const textStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const dataSourceStyle = {
            display: "block",
            marginLeft: 0,
            width: "150px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const formatStyle = {
            display: "block",
            marginLeft: 0,
            width: "100px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const comboStyle = {
            display: "block",
            height: "25px",
            zIndex: "0",
            vAlign: "middle",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const editComboStyle = {
            display: "block",
            width: "300px",
            height: "25px",
            zIndex: "0",
            vAlign: "middle",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        return (
            <div>
                {(() => {
                    switch (type) {
                        case "Word":
                            return (
                                <React.Fragment>
                                    <table style={tableStyle} id="Table1">
                                        <tr style={{border: '0px', height: '%100'}}>
                                            <td class="cell0" valign='top'><p style={pStyle}>&nbsp;Data Source</p></td>
                                            <td class="cell1" valign='top' style={{width: '200px'}, {border: '0px'}}>
                                                <table style={{width: '550px'}}>
                                                    <tr style={{border: '0px'}}>
                                                        <td style={{
                                                            width: '70%',
                                                            display: "inline-block"
                                                        }, {border: '0px'}}>
                                                            <EditableSelect onChange={e => this.onDataSourceChage(e)}
                                                                            comboStyle={editComboStyle}
                                                                            comboValue={this.getDatasourceValue(objeler.ElementProps.DataSource)}
                                                                            items={this.getDatasourceItems()}/>
                                                        </td>
                                                        <td style={{width: '50px'}, {border: '0px'}}>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td scope="col" colSpan="2" valign="top">
                                                <StructuredBindingPanel
                                                    kind="scalar"
                                                    binding={objeler.ElementProps.binding || objeler.ElementProps.Object?.binding || objeler.ElementProps.Object?.properties?.binding}
                                                    onBindingChange={this.onStructuredBindingChange}
                                                />
                                            </td>
                                        </tr>
                                        <tr style={{border: '0px', height: '%100'}}>
                                            <td scope="col" colSpan="2" valign="top">
                                                <Word
                                                    wrapperId="wordeditor"
                                                    name="wordeditor"
                                                    editorStyle={{
                                                        border: "1px solid #eeeeee",
                                                        fontFamily: 'Arial',
                                                        fontSize: '12px'
                                                        ,
                                                        minHeight: objeler.ElementProps.Object.properties.size.height + 'px'
                                                        ,
                                                        minWidth: objeler.ElementProps.Object.properties.size.width + 'px'
                                                        ,
                                                        maxWidth: objeler.ElementProps.Object.properties.size.width + 'px'
                                                    }}
                                                    wrapperStyle={{
                                                        maxWidth: '595px',
                                                        minWidth: '595px',
                                                        aligmentItems: 'center',
                                                        display: 'block'
                                                    }}
                                                    editorState={this.state.editorState}
                                                    toolbarClassName="toolbadrClassName"
                                                    ref={this.child}
                                                    wrapperClassName="wrapperClassName"
                                                    onEditorStateChange={e => this.onChangeEditorState(e)}
                                                    onTab={this.onTab}
                                                    toolbar={
                                                        {
                                                            options: ['inline', 'fontSize', 'fontFamily', 'textAlign', 'colorPicker', 'remove', 'history'],
                                                            inline: {
                                                                inDropdown: false,
                                                                className: undefined,
                                                                component: undefined,
                                                                dropdownClassName: undefined,
                                                                options: ['bold', 'italic',],
                                                            },
                                                            fontFamily: {
                                                                options: fontnameItems,
                                                                className: undefined,
                                                                component: undefined,
                                                                dropdownClassName: undefined,
                                                            },
                                                            fontSize: {
                                                                options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96],
                                                                className: undefined,
                                                                component: undefined,
                                                                dropdownClassName: undefined,
                                                            },
                                                        }
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </React.Fragment>);
                        case "TextBox":
                            return (
                                <React.Fragment>
                                    <table style={tableStyle} id="Table1">
                                        <tr style={{border: '0px'}}>
                                            <td class="cell0"><p style={pStyle}>&nbsp;Text : </p></td>
                                            <td class="cell1">
                        <textarea name="TextArea1" id="TextArea1"
                                  ref={abc => this.child = abc}
                                  defaultValue={objeler.ElementProps.Text}
                                  onChange={this.updateInputValue}
                                  style={textStyle} rows="1" cols="20" spellCheck="false">
                        </textarea>
                                            </td>
                                            <td class="cell0"><p style={pStyle}>&nbsp;Data Source</p></td>
                                            <td class="cell1" style={{width: '200px'}, {border: '0px'}}>
                                                <table style={{width: '250px'}}>
                                                    <tr style={{border: '0px'}}>
                                                        <td style={{
                                                            width: '70%',
                                                            display: "inline-block"
                                                        }, {border: '0px'}}>
                                                            <EditableSelect onChange={e => this.onDataSourceChage(e)}
                                                                            comboStyle={editComboStyle}
                                                                            comboValue={this.getDatasourceValue(objeler.ElementProps.DataSource)}
                                                                            items={this.getDatasourceItems()}/>
                                                        </td>
                                                        <td style={{width: '50px'}, {border: '0px'}}>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="cell0"><p style={pStyle}>Color:</p></td>
                                            <td class="cell1">
                                                <table>
                                                    <tr style={{border: '0px'}}>
                                                        <td style={{width: '7%'}, {border: '0px'}}>
                                                            <Colorpicker color={prp.Object.properties.colors?.color || prp.Object.properties.Color || '#000000'}
                                                                         onChangeCompleted={this.changeColor}
                                                                         style={{zIndex: '100'}}
                                                            />
                                                        </td>
                                                        <td style={{
                                                            width: '20%',
                                                            verticalAlign: 'middle',
                                                            alignContent: 'right'
                                                        }, {border: '0px'}}>Aligment:
                                                        </td>
                                                        <td style={{width: '20%'}}><ComboBox
                                                            onChange={e => this.onAlignChage(e)} comboStyle={comboStyle}
                                                            comboValue={objeler.ElementProps.Align}
                                                            items={aligmentItems}/></td>
                                                        <td style={{
                                                            width: '20%',
                                                            verticalAlign: 'middle',
                                                            alignContent: 'right'
                                                        }, {border: '0px'}}>Data Type:
                                                        </td>
                                                        <td style={{width: '20%'}}><ComboBox
                                                            onChange={e => this.onDataTypeChage(e)}
                                                            comboStyle={comboStyle}
                                                            comboValue={objeler.ElementProps.DataType}
                                                            items={dataTypeItems}/></td>
                                                    </tr>
                                                </table>
                                            </td>
                                            <td class="cell0"><p style={pStyle}>&nbsp;&nbsp;Format : </p></td>
                                            <td class="cell1">
                                                <table>
                                                    <tr>
                                                        <td style={{border: '0px'}}>
                          <textarea name="TextArea1" id="TextArea1"
                                    defaultValue={objeler.ElementProps.Format}
                                    onChange={e => objeler.ElementProps.Format = e.target.value}
                                    style={formatStyle} rows="1" cols="20" spellCheck="false">
                          </textarea>
                                                        </td>
                                                        <td style={{verticalAlign: 'middle'}, {border: '0px'}}>
                                                            <p>&nbsp;Source:</p></td>
                                                        <td style={{border: '0px'}}>
                            <textarea name="TextArea1" id="TextArea1"
                                      defaultValue={objeler.ElementProps.SourceFormat}
                                      onChange={e => objeler.ElementProps.SourceFormat = e.target.value}
                                      style={formatStyle} rows="1" cols="20" spellCheck="false">
                            </textarea>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="cell0"><p style={pStyle}>Font :</p></td>
                                            <td class="cell1">
                                                <table>
                                                    <tr>
                                                        <td class="cell1" colSpan="2">
                                                            <p>
                                                                <ComboBox onChange={e => this.onFontChage(e)}
                                                                          comboStyle={comboStyle}
                                                                          comboValue={objeler.ElementProps.Font}
                                                                          items={fontItems}
                                                                />
                                                            </p>
                                                        </td>
                                                        <td class="cell1">
                                                            <input name="TextArea1" id="TextArea1"
                                                                   type="number"
                                                                   onKeyDown={e => e.preventDefault()}
                                                                   min="1" max="50 " style={fontSizeStyle}
                                                                   onChange={e => this.onFontSizeChage(e)}
                                                                   value={objeler.ElementProps.FontSize}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr style={{border: '0px'}}>
                                                        <td style={{border: '0px'}}>
                                                            <div id="wb_Checkbox1">
                                                                <input type="checkbox" id="chkBold" name=""
                                                                       style={{display: "inline-block"}}
                                                                       onChange={e => this.onChangeBold(e)}
                                                                       defaultChecked={objeler.ElementProps.Bold}/>
                                                                <label for="Checkbox1"
                                                                       style={{left: "60px"}, {float: "right"}, {position: "absolute"}, {fontWeight: "bold"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bold</label>
                                                            </div>
                                                        </td>
                                                        <td style={{border: '0px'}}>
                                                            <div id="wb_Checkbox1">
                                                                <input type="checkbox" id="chkItalic" name=""
                                                                       style={{display: "inline-block"}}
                                                                       onChange={e => this.onChangeItalic(e)}
                                                                       defaultChecked={objeler.ElementProps.Italic}/>
                                                                <label for="Checkbox1"
                                                                       style={{left: "60px"}, {float: "right"}, {position: "absolute"}, {fontStyle: "italic"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Italic</label>
                                                            </div>
                                                        </td>
                                                        <td style={{border: '0px'}}>
                                                            <div id="wb_Checkbox1">
                                                                <input type="checkbox" id="chkMLine" name=""
                                                                       style={{display: "inline-block"}}
                                                                       onChange={e => this.onChangeMline(e)}
                                                                       defaultChecked={objeler.ElementProps.MLine}/>
                                                                <label for="Checkbox1"
                                                                       style={{left: "20px"}, {float: "left"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Wrap</label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                            <td class="cell0">
                                            </td>
                                            <td class="cell1"><p style={pStyle}>&nbsp;</p></td>
                                        </tr>
                                        <tr>
                                            <td scope="col" colSpan="4" valign="top">
                                                <StructuredBindingPanel
                                                    kind="scalar"
                                                    binding={objeler.ElementProps.binding || objeler.ElementProps.Object?.binding || objeler.ElementProps.Object?.properties?.binding}
                                                    onBindingChange={this.onStructuredBindingChange}
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                    <ScriptProperties
                                        IsScript={objeler.ElementProps.IsScript}
                                        Script={objeler.ElementProps.Script}
                                        onChangeScript={e => this.updateScriptValue(e)}
                                        onChangeIsScript={e => this.onChangeIsScript(e)}
                                    />
                                </React.Fragment>
                            );
                    }
                }).call(this)}
            </div>
        );
    }
}

export default TextProperties;
